<template>
  <div class="flex flex-col gap-8">

    <FormGroup :label="$t('forms.regulation.regulation_properties_form.name')" :error-text="form.errors?.name">
      <InputText
          data-cy="regulation-name-input-box"
          v-model="form.name"
          placeholder="e.g. R141"
          @change="form.validate('name')"
          :disabled="disabled"/>
    </FormGroup>

    <FormGroup :label="$t('forms.regulation.regulation_properties_form.description')" :error-text="form.errors?.description">
      <InputText
          data-cy="regulation-description-input-box"
          v-model="form.description"
          placeholder="e.g. Tyre Pressure Monitoring System (TPMS)"
          @change="form.validate('description')"
          :disabled="disabled"/>
    </FormGroup>

  </div>

  <template v-if="hasOnSaveListener || hasOnDeleteListener">
    <div class="flex justify-end space-x-3 mt-8">
      <Button data-cy="regulation-delete-btn"
              class="px-8"
              :label="$t('forms.common.delete')"
              severity="danger"
              v-if="hasOnDeleteListener && !disabled && form.id"
              text
              @click="$emit('on-delete', form)"
              :disabled="form.processing"/>

      <Button data-cy="regulation-save-btn"
              class="px-8"
              :label="$t('forms.common.save')"
              v-if="hasOnSaveListener && !disabled"
              @click="$emit('on-save', form)"
              :disabled="form.processing"/>
    </div>
  </template>
</template>

<script>
import FormGroup from "@/Components/FormGroup.vue";

export default {
  name: "RegulationPropertiesForm",
  components: {FormGroup},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasOnSaveListener() {
      return !!(this.$attrs?.onOnSave);
    },
    hasOnDeleteListener() {
      return !!(this.$attrs?.onOnDelete);
    },
  },
}
</script>

<style scoped>

</style>
